import { render } from "./SubscriptionProduct.vue?vue&type=template&id=2735d0a5"
import script from "./SubscriptionProduct.vue?vue&type=script&lang=js"
export * from "./SubscriptionProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__